<template>
	<popup title="Notes & dynamic variants" class="shopify-notes-popup" @close="close">
		<template v-slot:content>
			<div class="layout-column">
				<div class="layout-row attributes-actions">
					<v-switch label="Enable dynamic variants?"
					          info="This will allow you to send dynamic variants with each order to shopify."
										v-model="dv.enabled" :value="dv.enabled"	/>
				</div>

				<template v-if="dv.enabled">
					<div class="layout-row attributes-actions">
						<label class="label layout-row">
							<span>Dynamic variants</span>
						</label>
						<div class="flex"></div>
						<v-button @click="addVariant" border slim label="Add new variant" />
					</div>

					<div v-if="dv.variants && dv.variants.length>0" class="layout-column entries-table">
						<div class="panel-head">
							<div class="label">
								<label class="layout-row">Variant name
									<info-icon>
										<div>
											<p>
												This is the variant name to be added to your Shopify order details.
											</p>
										</div>
									</info-icon>
								</label>
							</div>

							<span class="field_mapping_arrow">
	<!--				        <inline-svg :src="require('@/assets/img/field_mapping_arrow.svg')"/>-->
					    </span>

							<div class="label ">
								<label class="layout-row">Value
									<info-icon>
										<div>
											<p>
												This can be the <b>"custom type"</b> input field in your funnel step OR a static text that you want to be pushed into your store.
											</p>
											<p>
												<i>In the example below the <b>"custom type"</b> is <b>"print_name"</b>:</i>
											</p>
										</div>
									</info-icon>
								</label>
							</div>

							<span style="min-width: 40px">
					    </span>

						</div>

						<div class="attribute-row layout-row" v-for="(entry, index) in dv.variants" :key="'key-'+index">
							<div class="attribute-name flex">
								<input-field placeholder="eg. Color, Size, Model" v-model="entry.name" />
							</div>
							<span class="field_mapping_arrow">
					        <inline-svg :src="require('@/assets/img/field_mapping_arrow.svg')"/>
					    </span>
							<div class="attribute-value flex">
								<input-field placeholder="eg. input_box_name" v-model="entry.value" />
							</div>
							<div style="min-width: 40px">
								<a @click="removeVariant(entry)" class="panel_item_btn delete_btn">
									<inline-svg :src="require('@/assets/img/popup_close.svg')"/>
								</a>
							</div>
						</div>
					</div>

					<div v-else class="layout-row">
						<div class="flex"></div>
						<p class="info-message" >
							No dynamic variants created!
						</p>
						<div class="flex"></div>
					</div>
				</template>

			</div>
			<div class="layout-column">

				<div class="layout-row attributes-actions">
					<v-switch label="Enable sending custom notes and attributes?"
					          info="This will allow you to send custom notes and attributes with each order to shopify."
					          v-model="c.enable_notes" :value="c.enable_notes"	/>
				</div>

				<template v-if="c.enable_notes">
					<div class="custom-note">
						<input-field label="Note" placeholder="Custom note" v-model="c.note" >
							<template v-slot:info>
								<div>
									<p>
										This can be the <b>"custom type"</b> input field in your funnel step OR a static text that you want to be pushed into your store.
									</p>
									<p>
										<i>In the example below the <b>"custom type"</b> is <b>"print_name"</b>:</i>
										<img style="width: 300px" :src="require('@/assets/img/custom_type_input.png')"/>
									</p>
									<p class="info-message">
										Use "_" underscore instead of spaces when setting this to a custom type input field.
									</p>
								</div>
							</template>
						</input-field>
					</div>
					<div class="layout-row attributes-actions">
						<label class="label layout-row">
							<span>Attributes</span>
							<info-icon>
								<div>
									<p>Attributes can be used to send custom note attributes into shopify,
										Each attribute can have a static text value, or a dynamic value based on the input of your customers.
									</p>
									<p >
										<i>Can be used to send custom customer instructions text into Shopify.</i>
									</p>
								</div>
							</info-icon>
						</label>
						<div class="flex"></div>
						<v-button @click="addAttr" border slim label="Add new attribute" />
					</div>

					<div v-if="c.attributes && c.attributes.length>0" class="layout-column entries-table">
						<div class="panel-head">
							<div class="label">
								<label class="layout-row">Name
									<info-icon>
										<div>
											<p>
												This is the attribute name under which the value will be stored in your Shopify order details.
											</p>
										</div>
									</info-icon>
								</label>
							</div>

							<span class="field_mapping_arrow">
	<!--				        <inline-svg :src="require('@/assets/img/field_mapping_arrow.svg')"/>-->
					    </span>

							<div class="label ">
								<label class="layout-row">Value
									<info-icon>
										<div>
											<p>
												This can be the <b>"custom type"</b> input field in your funnel step OR a static text that you want to be pushed into your store.
											</p>
											<p>
												<i>In the example below the <b>"custom type"</b> is <b>"print_name"</b>:</i>
												<img style="width: 300px" :src="require('@/assets/img/custom_type_input.png')"/>
											</p>
										</div>
									</info-icon>
								</label>
							</div>

							<span style="min-width: 40px">
					    </span>

						</div>

						<div class="attribute-row layout-row" v-for="(entry, index) in c.attributes" :key="'key-'+index">
							<div class="attribute-name flex">
								<input-field placeholder="color" v-model="entry.name" />
							</div>
							<span class="field_mapping_arrow">
					        <inline-svg :src="require('@/assets/img/field_mapping_arrow.svg')"/>
					    </span>
							<div class="attribute-value flex">
								<input-field placeholder="custom_type" v-model="entry.value" />
							</div>
							<div style="min-width: 40px">
								<a @click="removeAttr(entry)" class="panel_item_btn delete_btn">
									<inline-svg :src="require('@/assets/img/popup_close.svg')"/>
								</a>
							</div>
						</div>
					</div>

					<div v-else class="layout-row">
						<div class="flex"></div>
						<p class="info-message" >
							No attributes created!
						</p>
						<div class="flex"></div>
					</div>
				</template>

			</div>
		</template>
		<template v-slot:actions>
			<v-button label="Done" @click="done" />
		</template>
	</popup>
</template>

<script>
import Popup from "@/components/base/popup";
import VButton from "@/components/base/v-button";
import VSwitch from "@/components/base/v-switch";
import InputField from "@/components/base/input-field";
import InfoIcon from "@/components/base/info-icon";
export default {
	name: "shopify-notes-popup",
	components: {InfoIcon, InputField, VSwitch, VButton, Popup},
	props: ["config", "dynamicVariantsConfig"],
	data() {
		return {
			c: this.config ? JSON.parse(JSON.stringify(this.config)) : {
				enable_notes: false,
				note: "",
				attributes: [
					{name: "", value:""}
				],
				dynamic_variants: [
					{name: "", value:""}
				],
			},
			dv: this.dynamicVariantsConfig ? JSON.parse(JSON.stringify(this.dynamicVariantsConfig)) :
			{
				enabled: false,
				variants: [
					{name: "color", value:"red"}
				]},
		}
	},
	methods: {
		removeAttr(entry) {
			if (!this.c.attributes)
				this.$set(this.c, "attributes", []);
			let index = this.c.attributes.indexOf(entry);
			if (index >= 0) this.c.attributes.splice(index,1);
		},
		addAttr() {
			if (!this.c.attributes)
				this.$set(this.c, "attributes", []);
			this.c.attributes.push({name: "", value: ""})
		},
		removeVariant(entry) {
			if (!this.dv.variants)
				this.$set(this.dv, "variants", []);
			let index = this.dv.variants.indexOf(entry);
			if (index >= 0) this.dv.variants.splice(index,1);
		},
		addVariant() {
			if (!this.dv.variants)
				this.$set(this.dv, "variants", []);
			this.dv.variants.push({name: "", value: ""})
		},
		close() {
			this.$emit('close');
		},
		done() {
			this.$emit('done', this.c, this.dv);
		}
	}
}
</script>

<style lang="scss" scoped>
.shopify-notes-popup {
	.custom-note {
		margin: 15px 0;
	}
	.attributes-actions {
		//border-top: 1px solid $grey;
		align-items: center;
		padding: 10px 10px;
		border-radius: 3px;
		background: $light-blue;
		height: 42px;
		margin-top: 10px;
	}
	.attribute-row {
		padding: 5px 5px;
	}
	.panel-head {
		padding: 10px 5px;
		font-weight: 600;
		margin-top: 10px;
		color: $grey;
		.label {
			width: 100%;
		}
	}
	.field_mapping_arrow {
		min-width: 40px;
		align-items: center;
		display: flex;
	}
	.label {
		color: $blue;
		font-weight: 600;
	}
}
</style>
<style lang="scss">
.shopify-notes-popup {
	.popup {
	}
}
</style>
